import browserStorage from 'store';

export const AUTH_SESSION_MARKER_KEY = 'authSessionMarker';

interface AuthSessionMarkerStorage {
  get(key: string): unknown;
  set(key: string, value: unknown): void;
  remove(key: string): void;
}

// This opaque marker follows persisted Auth0 state across tabs; it never contains token or user data.
export const getOrCreateAuthSessionMarker = (storage: AuthSessionMarkerStorage = browserStorage): string => {
  const existingMarker = storage.get(AUTH_SESSION_MARKER_KEY);
  if (existingMarker) {
    return String(existingMarker);
  }

  const marker = crypto?.randomUUID?.() || `${Date.now()}-${Math.random()}`;
  storage.set(AUTH_SESSION_MARKER_KEY, marker);
  return marker;
};

export const clearAuthSessionMarker = (storage: AuthSessionMarkerStorage = browserStorage) =>
  storage.remove(AUTH_SESSION_MARKER_KEY);
